import { AnyAction } from 'redux';
import {
  GlobalAction,
  GlobalActions,
  VorversicherungChanged,
} from '@ps20-frontend/shop-integration-redux';

export const vorversicherungReducer = function (
  sectionState: boolean = null,
  action: AnyAction,
): boolean {
  if (action.type === GlobalActions.VORVERSICHERUNG_VORHANDEN_CHANGED) {
    const globalAction: GlobalAction<VorversicherungChanged> = action;
    return globalAction.payload.vorhanden;
  }
  return sectionState;
};
